module.exports = __webpack_public_path__ + "img/lianxi2.343c2d97.png";